
/* styles */
require("!!../../../../../../../../azure/movemais.client/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/style-rewriter?id=data-v-29ddc2b9&scoped=true!sass-loader?sourceMap!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=styles&index=0!./company-data.vue")

var Component = require("!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./company-data.js"),
  /* template */
  require("!!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/template-compiler?id=data-v-29ddc2b9!../../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=template&index=0!./company-data.vue"),
  /* scopeId */
  "data-v-29ddc2b9",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/common/adhesion/company-data.vue
// module id = 228
// module chunks = 1